import React, { useEffect } from 'react';

const Logout = () => {
    let logoutInitiated = false;
    useEffect(() => {
        const logout = async () => {
            try {
                if (logoutInitiated) {
                    return;
                }
                logoutInitiated = true;
                // Make a request to the logout API
                const response = await fetch('/api/logout');
                if (response.ok) {
                    // Redirect to the login page on successful logout
                    setTimeout(() => { window.location.href = '/login'; }, 300);
                } else {
                    // Handle error case
                    console.error('Logout failed');
                }
            } catch (error) {
                console.error('Logout failed', error);
            }
        };

        logout();
    }, []);

    return <div>Logging out...</div>;
};

export default Logout;